import { render, staticRenderFns } from "./nopermisson.vue?vue&type=template&id=f62476d4&scoped=true"
import script from "./nopermisson.vue?vue&type=script&lang=js"
export * from "./nopermisson.vue?vue&type=script&lang=js"
import style0 from "./nopermisson.vue?vue&type=style&index=0&id=f62476d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62476d4",
  null
  
)

export default component.exports